import React from 'react'
import { ShieldAlert, Shield } from 'lucide-react'
import { Button } from '../ui/Button'
import { Card } from '../ui/Card'

interface VerifyIdentityBannerProps {
  onVerifyClick: () => void
}

export const VerifyIdentityBanner: React.FC<VerifyIdentityBannerProps> = ({ onVerifyClick }) => {
  return (
    <Card className="p-6 border-amber-300 dark:border-amber-700/60 bg-amber-50 dark:bg-amber-950/30">
      <div className="flex items-start gap-3">
        <ShieldAlert
          aria-hidden="true"
          className="h-5 w-5 text-amber-600 dark:text-amber-400 mt-0.5 flex-shrink-0"
        />
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-amber-900 dark:text-amber-100">
            Identity Verification Required
          </h3>
          <p className="text-sm text-amber-800 dark:text-amber-200/90 mt-1">
            Complete your identity verification to access all platform features and begin your 1031 exchange.
          </p>
          <div className="mt-3">
            <Button
              size="sm"
              className="bg-amber-600 hover:bg-amber-700 text-white"
              onClick={onVerifyClick}
            >
              <Shield className="h-4 w-4 mr-2" />
              Verify Identity
            </Button>
          </div>
        </div>
      </div>
    </Card>
  )
}
